// Lightweight mobile nav + account menu for ERB pages (no Bootstrap JS).
document.addEventListener("DOMContentLoaded", () => {
  const toggles = document.querySelectorAll("[data-nav-toggle]");
  toggles.forEach((btn) => {
    const targetId = btn.getAttribute("data-nav-toggle");
    if (!targetId) return;
    const panel = document.getElementById(targetId);
    if (!panel) return;

    btn.addEventListener("click", () => {
      const open = panel.classList.toggle("hidden") === false;
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.querySelectorAll("[data-menu-toggle]").forEach((btn) => {
    const menuId = btn.getAttribute("data-menu-toggle");
    if (!menuId) return;
    const menu = document.getElementById(menuId);
    if (!menu) return;

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      menu.classList.toggle("hidden");
    });
  });

  document.addEventListener("click", () => {
    document.querySelectorAll("[data-menu]").forEach((menu) => {
      menu.classList.add("hidden");
    });
  });
});
